module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "main"
    }
  }, [_c('button', {
    staticClass: "fullBtn",
    on: {
      "click": _vm.getUser
    }
  }, [_c('inline-svg', {
    staticClass: "googleIcon",
    attrs: {
      "src": require('../../assets/svg/googleicon.svg').default
    }
  }), _vm._v("\n    " + _vm._s(_vm.$t("user.loginButton.button")) + "\n  ")], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c23af35a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/LoginButton.vue
// module id = 328
// module chunks = 0 6